import { useSelector } from 'react-redux';
import { useState, useEffect } from 'react';
import { useGetServiceProvidersQuery } from '../../../data/claim';
import { SLICES } from '../../../constants/slices';

export const useVetPracticeSearch = (
  onSelect,
  selectedPets,
  activeVet,
  showAlreadyLinkedError,
  setShowAlreadyLinkedError
) => {
  const vetDetailsList = useSelector((state) => state?.[SLICES.VET_DETAILS].vetDetailsList);
  const { authDetails } = useSelector((state) => state?.[SLICES.AUTHENTICATION]);
  const { auth0AccessToken } = authDetails;
  const [isVetSelected, setIsVetSelected] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const { data: allServiceProviders = [], isLoading } = useGetServiceProvidersQuery(auth0AccessToken, {
    skip: !auth0AccessToken
  });

  useEffect(() => {
    if (selectedPets.length && activeVet) {
      handleSelect(activeVet);
    }
  }, [selectedPets, activeVet]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleSearch = (searchValue) => {
    setSearchValue(searchValue);
    const filteredResults = allServiceProviders.filter((sp) =>
      sp.serviceProvider.toLowerCase().includes(searchValue.toLowerCase())
    );

    setSearchResults(filteredResults);
    setShowAlreadyLinkedError(false);
  };

  const handleSelect = (selectedVet) => {
    const isAlreadyLinked = vetDetailsList?.some(
      (vet) =>
        vet.ServiceProviderNumber === selectedVet.serviceProviderNumber &&
        vet.PetsTreated?.some((pet) =>
          selectedPets?.some((selectedPet) => selectedPet.policyNumber === pet.PolicyNumber)
        )
    );

    if (isAlreadyLinked) {
      setShowAlreadyLinkedError(true);
      return;
    }
    setShowAlreadyLinkedError(false);
    setIsVetSelected(true);
    onSelect(selectedVet);
    setSearchValue('');
  };

  const showNoResultsError = searchValue.trim() !== '' && searchResults.length === 0;

  return {
    isVetSelected,
    searchValue,
    searchResults,
    isLoading,
    handleSearch,
    handleSelect,
    showNoResultsError,
    showAlreadyLinkedError
  };
};
